<template>
	<div class="weijiekongdan">
		<el-scrollbar id="menuWarpper" style="height:calc(100%);">
			<el-main>
				<div class="header" ref="header">
					<div class="headerTop">
						<div class="header-con">
							<div class="header-con-form">
								<div class="header-con-form-item">
									<div class="sousuomingcheng">客户:</div>
									<el-input v-model="kehu" class="form-item-inputcpx" placeholder="请输入"
										@keyup.enter.native="ChaXun(1)" clearable>
									</el-input>
								</div>
								
								<!-- <div class="header-con-form-item">
									<div class="sousuomingcheng">起始日期:</div>
									<el-date-picker v-model="kaishishijian" :clearable="false" type="date"
										range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期"
										end-placeholder="结束日期">
									</el-date-picker>
								</div>
								<div class="header-con-form-item">
									<div class="sousuomingcheng">终止日期:</div>
									<el-date-picker v-model="jieshushijian" :clearable="false" type="date"
										range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期"
										end-placeholder="结束日期">
									</el-date-picker>
								</div> -->

								<!-- <div class="header-con-form-item">
									<div class="sousuomingcheng">产品线:</div>
									
									<el-select v-model="chanpinxian" placeholder="请选择" clearable multiple
										transfer="true" size="small" style="width: 230px;" @change="dianjichanpinxian"
										popper-class="eloption">
										<el-option v-for="item in staff" :key="item.Code" :label="item.Name"
											:value="item.Code" />
									</el-select>
								</div> -->

								<el-button class="anniuclass" type="success" @click="QBGDCX(1)" :disabled="isChaXun">查询
								</el-button>
								<!-- <span style="font-size: 12px;color: red;margin-left: 10px;margin-bottom: 15px;">注:排序为本地排序，若要查看完整排序，请将每页显示数条到大于总条数</span> -->
							</div>

						</div>

					</div>
				</div>
				<div class="maina" v-bind:style="{height:EchartsHeight}">
					<el-table ref="tableData" @sort-change="sortChange" fit v-loading="loading" id="out-table"
						:data="tableDataXS" height="100%" highlight-current-row resizable border>
						<el-table-column align="center" type="index" label="序号" width="50" >
							
						</el-table-column>
						<el-table-column label="客户名称" align="center" fit prop="COMPANY_NAME" min-width="180" >
							<template slot-scope="scope">
								<div v-if="scope.row.beijingse=='hong'"
									:style="{ color: '#FF3A3A' }">
									{{scope.row.COMPANY_NAME}}
								</div>
								<div v-else-if="scope.row.beijingse=='huang'"
									:style="{ color: '#FFD700' }">
									{{scope.row.COMPANY_NAME}}
								</div>
								<div v-else>
									{{scope.row.COMPANY_NAME}}
								</div>
							
							</template>
						</el-table-column>
						<el-table-column label="客户编号" align="center" fit prop="COMPANY_NUMBER" />
						
						<el-table-column v-for="(item, index) in tableData" fit :key="index" :sortable="true"
							:label="item.Name" align="center">
							<template slot-scope="scope">
								<span>{{scope.row.LineData[index].LINE_INFO_COUNT}}</span>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="ISDELEGATE" label="是否代理商客户" width="100"
							show-overflow-tooltip>
							<template slot-scope="scope">
								<div type="success" v-if="scope.row.ISDELEGATE==0">否</div>
								<div type="primary" v-if="scope.row.ISDELEGATE==1">是</div>
													
							</template>
						</el-table-column>
						<el-table-column label="是否交服务费" align="center" fit prop="ISBOUGHT" >
						<template slot-scope="scope">
							<div type="success" v-if="scope.row.ISBOUGHT==0">否</div>
							<div type="primary" v-if="scope.row.ISBOUGHT==1">是</div>
												
						</template>
						</el-table-column>
						<el-table-column label="服务开始时间" align="center" fit prop="PAYBEGINDATE" width="150" />
						<el-table-column label="服务结束时间" align="center" fit prop="PAYENDDATE" width="150"/>
						<el-table-column label="等级" align="center" fit prop="SLEVEL" />
						<el-table-column label="缴费金额" align="center" fit prop="PAYMENTS" />
						<el-table-column label="购买产品" align="center" fit prop="BUY_LINE_NAME" min-width="180" />


					</el-table>
				</div>

				<div class="footer" ref="footer">
					<pagination :allPage="allPage" :page-sizes="[100,300,500,1000,5000]" :pageSize="pageSize"
						:currIndex="currPage" @hanSiChange="hanSiChange" @hanCurrChange="hanCurrChange"></pagination>
				</div>
			</el-main>
		</el-scrollbar>


	</div>
</template>

<script>
	import PinyinMatch from "pinyin-match";
	import FileSaver from "file-saver";
	import XLSX from "xlsx";
	export default {
		name: "customerRanking",
		data() {
			return {
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				dormitory: [],
				xianshi: false,
				colors: ['#FFFF00', '#FFFF00', '#FFFF00', '#FFFF00', '#FFFF00'],
				isChaXun: false,
				kehumingcheng: '',
				dangqiandanhao: "",
				jdxzyjwcsj: false,
				EchartsHeight: (document.body.clientHeight - 220) + 'px',
				WenTileixingList: [],
				staffcopy: [],
				staff: [], //产品线
				staffz: [], //产品线
				chanpinxian: "", //产品线
				kaishishijian: "",
				jieshushijian: "",
				loading: false,
				WanChengshijian: "",
				WanChengshijianKS: "",
				WanChengshijianJZ: "",
				currPage: 1,
				pageSize: 50,
				allPage: 0,
				yjwcallPage: 0,
				XMkaishishijian: "2022-03-01",
				JTjieshushijian: "",
				gongdanzhuangtai: "",
				gongdanzhuangtaiList: [{
						Code: "0",
						Name: "已撤销",
					},
					{
						Code: "1",
						Name: "已发起",
					},
					{
						Code: "2",
						Name: "已接单",
					},
					{
						Code: "3",
						Name: "已处理",
					},
					{
						Code: "4",
						Name: "已驳回",
					},
					{
						Code: "5",
						Name: "已完成",
					}
				],
				tableData: [],
				tableDataXS: [],
				tableDataXSYS: [],
				SXtableData: [],
				kehu: "",
				sortType:"",
				proptype:"",

			};
		},
		updated() {
			// myTable是表格的ref属性值
			if (this.$refs.tableData && this.$refs.tableData.doLayout) {
				this.$refs.tableData.doLayout();
			}
		},
		mounted() {
			const that = this;

			window.onresize = () => {
				// return (() => {

				window.screenHeight = document.body.clientHeight

				// that.EchartsHeight = (window.screenHeight - this.$refs.header.offsetHeight - this.$refs
				// 	.footer.offsetHeight - 70) + 'px'
				that.EchartsHeight = (window.screenHeight - this.$refs.header.offsetHeight - 70) + 'px'
				if (this.$refs.tableData && this.$refs.tableData.doLayout) {
					this.$refs.tableData.doLayout();
				}

				// })()
			}
			this.getPerson()
			this.getWenTileixing()
			this.addDate();
			this.currPage = 1;
			// this.ChaXun(this.currPage);
			this.QBGDCX(this.currPage)
			// this.SJSXChaXun()

		},
		activated() {
			const that = this;

			window.onresize = () => {
				// return (() => {

				window.screenHeight = document.body.clientHeight
				that.EchartsHeight = (window.screenHeight - this.$refs.header.offsetHeight - 70) + 'px'
				// that.EchartsHeight = (window.screenHeight - this.$refs.header.offsetHeight - this.$refs
				// 	.footer.offsetHeight - 70) + 'px'
				if (this.$refs.tableData && this.$refs.tableData.doLayout) {
					this.$refs.tableData.doLayout();
				}
				// })()
			}
			// this.getPerson()
			// this.getWenTileixing()
			// this.addDate();
			// this.currPage = 1;
			// this.ChaXun(this.currPage);
		},
		// beforeRouteEnter(to, form, next) {
		// 	next(vm => {

		// 		vm.ChaXun(1)

		// 	})

		// },
		methods: {
			getDay(day) {
				var today = new Date();
				var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
				today.setTime(targetday_milliseconds);

				var tYear = today.getFullYear();
				var tMonth = today.getMonth();
				var tDate = today.getDate();
				var tHours = today.getHours();
				var tMinutes = today.getMinutes();
				var tSeconds = today.getSeconds();
				tMonth = this.doHandleMonth(tMonth + 1);
				tDate = this.doHandleMonth(tDate);
				return tYear + "-" + tMonth + "-"  + tDate+""+tHours+":"+tMinutes+":"+tSeconds;
			},
			getDayCR(day, crday) {
				
				var today = new Date(crday);
				var targetday_milliseconds = today.getTime() - 1000 * 60 * 60 * 24 * day;
				today.setTime(targetday_milliseconds);

				var tYear = today.getFullYear();
				var tMonth = today.getMonth();
				var tDate = today.getDate();
				var tHours = today.getHours();
				var tMinutes = today.getMinutes();
				var tSeconds = today.getSeconds();
			
				tMonth = this.doHandleMonth(tMonth + 1);
				tDate = this.doHandleMonth(tDate);
				tHours = this.doHandleMonth(tHours);
				tMinutes = this.doHandleMonth(tMinutes);
				tSeconds = this.doHandleMonth(tSeconds);
				return tYear + "-" + tMonth + "-" + tDate+" "+tHours+":"+tMinutes+":"+tSeconds;
			},
			compare(date1, date2) {
				console.log("开始",date1,'结束',date2)
				let dates1 = new Date(date1);
				let dates2 = new Date(date2);
				if (dates1 > dates2) {
					return true
				} else {
					return false
				}
			},
			currentTime() {
				var date = new Date();
				var year = date.getFullYear(); //月份从0~11，所以加一
				let month = date.getMonth();
				console.log("month", month);
				var dateArr = [
					date.getMonth() + 1,
					date.getDate(),
					date.getHours(),
					date.getMinutes(),
					date.getSeconds(),
				];
				//如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
				for (var i = 0; i < dateArr.length; i++) {
					if (dateArr[i] >= 1 && dateArr[i] <= 9) {
						dateArr[i] = "0" + dateArr[i];
					}
				}
				var strDate =
					year +
					"-" +
					dateArr[0] +
					"-" +
					dateArr[1] +
					" " +
					dateArr[2] +
					":" +
					dateArr[3] +
					":" +
					dateArr[4];
				//此处可以拿外部的变量接收  strDate:2022-05-01 13:25:30
				//this.date = strDate;
				// console.log("strDate", strDate);
				return strDate;
			},

			doHandleMonth(month) {
				var m = month;
				if (month.toString().length == 1) {
					m = "0" + month;
				}
				return m;
			},
			//以下代码放在methods中
			sortChange(column) {
				//打印看看参数有哪些？
				this.currPage = 1;
				for (var i in this.tableData) {
					if (this.tableData[i].Name == column.column.label) {
						this.proptype = this.tableData[i].Code; // 将键名prop赋值给变量proptype
					}
				}

				if (column.order === 'ascending') {
					// this.tableDataXS.sort(this.ascSortFun)
					// this.$nextTick(() => {
					// 	// myTable是表格的ref属性值
					// 	if (this.$refs.tableData && this.$refs.tableData.doLayout) {
					// 		this.$refs.tableData.doLayout();
					// 	}

					// })
					this.sortType='asc';
					this.ChaXun(1)
				} else if (column.order === 'descending') {
					// this.tableDataXS.sort(this.desSortFun)
					// this.$nextTick(() => {
					// 	// myTable是表格的ref属性值
					// 	if (this.$refs.tableData && this.$refs.tableData.doLayout) {
					// 		this.$refs.tableData.doLayout();
					// 	}
					// })
					this.sortType='desc';
					this.ChaXun(1)
				} else {
					//取消排序则重新获console.log(this.tableDataXSYS,this.tableDataXS)取列表，恢复默认状态。
					// this.proptype = 2;
					// this.tableDataXS.sort(this.desSortFun)
					this.ChaXun(1)

				}

				// //排序默认是从第一页开始
				//  this.listQuery.page = 1;
				//  //排序的字段是属性名
				//  this.listQuery.param.sort = column.prop;
				//  //排序的方式是根据上下选择来确定
				//  this.listQuery.param.asc = (column.order == 'ascending' ? true : false);
				//  //此方法为获取数据的方法
				//  this.getPage();
			},
			getSummaries(param) {

				const {
					columns,
					data
				} = param;

				// console.log("getSummaries", param, columns, data)
				const sums = [];

				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '总计';
						return;
					}
					if (index === 1) {
						sums[index] = 'N/A';
						return;
					}
					var arr = [];
					var proptype = "";
					for (var i in this.tableData) {
						if (this.tableData[i].Name == column.label) {
							proptype = this.tableData[i].Code; // 将键名prop赋值给变量proptype
						}
					}

					for (var z in data) {
						for (var j in data[z].LineData) {
							if (data[z].LineData[j].LineCode == proptype) {
								arr.push(data[z].LineData[j])
							}
						}
					}
					// console.log(arr)
					const values = arr.map(item => Number(item.LineTotal));
					if (!values.every(value => isNaN(value))) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						sums[index] += ' 条';
					} else {
						sums[index] = 'N/A';
					}
				});

				return sums;

			},
			ascSortFun(a, b) {
				var aint = 0;
				var bint = 0;
				for (var i in a.LineData) {
					if (a.LineData[i].Code == this.proptype) {
						aint = a.LineData[i].LINE_INFO_COUNT;
					}
				}
				for (var j in b.LineData) {
					if (b.LineData[j].Code == this.proptype) {
						bint = b.LineData[j].LINE_INFO_COUNT;
					}
				}
				return aint - bint;
			},
			//降序排列方法
			desSortFun(a, b) {

				// return b[this.proptype] - a[this.proptype];
				var aint = 0;
				var bint = 0;
				for (var i in a.LineData) {
					// console.log(a.LineData[i].Code, a.LineData[i].LINE_INFO_COUNT,this.proptype);
					if (a.LineData[i].Code == this.proptype) {
						aint = a.LineData[i].LINE_INFO_COUNT;
					}
				}
				for (var j in b.LineData) {
					if (b.LineData[j].Code == this.proptype) {
						bint = b.LineData[j].LINE_INFO_COUNT;
					}
				}
				return bint - aint;
			},
			QBGDCX(index) {
				// if (this.JTjieshushijian == null || this.JTjieshushijian == "" || this.JTjieshushijian == undefined) {
				this.ChaXun(index)
				// } else {
				// 	this.SJSXChaXun(index)
				// }

			},
			daochuwendang() {
				this.xianshi = true;
				setTimeout(() => { //设置延迟执行
					this.exportExcel()
				}, 1000);

			},
			exportExcel() { //执行此方法导出Excel表格
				// 为el-table添加一个id：out-table
				// 当el-table使用了fixed时会导出两次数据，所以要先进行判断

				var fix = document.querySelector('.el-table__fixed');
				var wb;
				if (fix) {
					// 如果有fixed，先移除，然后再添加上
					wb = XLSX.utils.table_to_book(document.querySelector("#out-table").removeChild(fix))
					document.querySelector("#out-table").appendChild(fix)
				} else {
					wb = XLSX.utils.table_to_book(document.querySelector("#out-table"))
				}
				var wbout = XLSX.write(wb, {
					bookType: "xlsx",
					bookSST: true,
					type: "array"
				});
				try {
					FileSaver.saveAs(
						new Blob([wbout], {
							type: "application/octet-stream"
						}),
						// 导出的文件名称
						"全部工单查询" + new Date() + ".xlsx"
					)
				} catch (e) {
					if (typeof console !== "undefined") console.log(e, wbout);
				}
				setTimeout(() => { //设置延迟执行
					this.xianshi = false;
				}, 1000);

				return wbout;
			},

			dianzhuangtai() {
				this.currPage = 1;
				// this.ChaXun(this.currPage)
				// this.SJSXChaXun()
				this.QBGDCX(this.currPage)
			},
			dianjichanpinxian() {
				this.staff = this.staffz;
				this.currPage = 1;
				// this.ChaXun(this.currPage)
				// this.SJSXChaXun()
				this.QBGDCX(this.currPage)
			},
			bindSelectChange(val) {
				if (val) {
					this.staff = this.staffcopy.filter((item) => {
						return PinyinMatch.match(item.Name, val) //(需要过滤的名称，输入的关键词)
					})
				} else {
					this.staff = this.staffcopy
				}
			},
			//双击查看工单
			shuangjiChaKan(row) {

				this.$router.push({
					path: "quanbugongdanxq",
					query: {
						zhuangtai: 'N',
						qianyiyemingcheng: '全部工单查询',
						code: row.CODE,
						qianyiyemianglujing: "/home/quanbugongdanchaxun"
					}
				});


			},
			/**获取类型*/
			getWenTileixing() {
				this.loading = true;

				this.$request({
						method: "GET",
						url: "Dictionary/GetGdLx",
					})
					.then((res) => {
						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {
							this.WenTileixingList = res.Data;
						}

					})
					.catch((err) => {
						this.loading = false;
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},
			//查询
			ChaXun(index) {
				this.currPage = index;
				this.loading = true;
				this.isChaXun = true;
				// url: 'ACCOUNT/GetCustomerInfoStatList?launchStartDate=' +
				// 							encodeURIComponent(
				// 								this.kaishishijian + " 00:00:00") + "&launchEndDate=" + encodeURIComponent(this
				// 								.jieshushijian + " 23:59:59") + "&kh=" + encodeURIComponent(
				// 								this.kehu),

				this.$request({
						method: "GET",
						url: 'ACCOUNT/GetCustomerInfoStatList?kh=' + encodeURIComponent(this.kehu) +
							"&sortType=" + encodeURIComponent(this.sortType) +
							"&bylineCode=" + encodeURIComponent(this.proptype) +
							"&pageIndex=" + encodeURIComponent(index) + "&pageSize=" + encodeURIComponent(this
								.pageSize),
					})
					.then((res) => {
						this.isChaXun = false;
						this.loading = false;

						if (res.Code == '0' || res.Code == 0) {
							// var dic={};

							for (var i in res.Data) {
								var arr = [];
								res.Data[i].PAYENDDATE=res.Data[i].PAYENDDATE==null?null:res.Data[i].PAYENDDATE.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
								res.Data[i].PAYBEGINDATE=res.Data[i].PAYBEGINDATE==null?null:res.Data[i].PAYBEGINDATE.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
								
								for (var yy in this.tableData) {
									arr.push(JSON.parse(JSON.stringify(this.tableData[yy])))
								}
								this.$set(res.Data[i], 'LineData', arr);
								var zongshuzhi = 0;
								for (var y in res.Data[i].LINEGROUP) {
									zongshuzhi = zongshuzhi + res.Data[i].LINEGROUP[y].LINE_INFO_COUNT * 1;

								}
								for (var w in res.Data[i].LineData) {
									if (res.Data[i].LINEGROUP.length != 0) {
										for (var j in res.Data[i].LINEGROUP) {

											if (res.Data[i].LineData[w].Code == res.Data[i].LINEGROUP[j].PRODUCT_LINE *
												1) {

												res.Data[i].LineData[w].LINE_INFO_COUNT = res.Data[i].LINEGROUP[j]
													.LINE_INFO_COUNT;
											}
											if (res.Data[i].LineData[w].Code == 0) {

												res.Data[i].LineData[w].LINE_INFO_COUNT = zongshuzhi;
												// this.$set(arr[w], 'LINE_INFO_COUNT', zongshuzhi);

											}
										}
									}


									// res.Data[i].LineData[0].LINE_INFO_COUNT=zongshuzhi;
								}
								this.$set(res.Data[i], 'LineData', arr);
								
								
								if (res.Data[i].PAYENDDATE !== null) {
									
									var liushitianqian = this.getDayCR(60, res.Data[i].PAYENDDATE);
								
									if(this.compare(this.currentTime(),liushitianqian)&&this.compare(res.Data[i].PAYENDDATE,this.currentTime())){
										
										this.$set(res.Data[i], 'beijingse', "huang");
									}else if(this.compare(this.currentTime(),liushitianqian)&&this.compare(this.currentTime(),res.Data[i].PAYENDDATE)){
										
										this.$set(res.Data[i], 'beijingse', "hong");
									}else{
										
										this.$set(res.Data[i], 'beijingse', "hei");
									}
								}
							}
							this.tableDataXS = res.Data;
							// console.log("this.tableDataXS",this.tableDataXS)
							// this.tableDataXSYS = res.Data.JobStatData;
							// this.tableData = res.Data.ProductLine;
							// this.tableDataXS = res.Data.JobStatData;
							// this.proptype = 2;
							// this.tableDataXS.sort(this.desSortFun)
						}


						this.allPage = res.Total
						if (this.$refs.header.offsetHeight == 0) {
							this.EchartsHeight = (document.body.clientHeight - 170) + 'px'

						} else {
							// this.EchartsHeight = (document.body.clientHeight - this.$refs.header.offsetHeight -
							// 	130) + 'px'
							this.EchartsHeight = (document.body.clientHeight - this.$refs.header.offsetHeight -
								120) + 'px'

						}

						// this.exportExcel()
					})
					.catch((err) => {
						this.isChaXun = false;
						this.loading = false;
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});


			},
			/**获取产品线 */
			getPerson() {
				this.loading = true;

				this.$request({
						method: "GET",
						url: "Dictionary/GetProducts",
					})
					.then((res) => {
						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {
							var arr = [];
							var arr1 = [];

							

							for (var i in res.Data) {

								this.$set(res.Data[i], 'LINE_INFO_COUNT', 0)
								arr.push(res.Data[i])
								arr1.push(res.Data[i])

							}
							var div1 = {
								Code: 0,
								MnemonicCode: "CWJK",
								Name: "问题总数",
								LINE_INFO_COUNT: 0
							};
							arr.push(div1)
							this.tableDataXSYS = arr;
							this.tableData = arr;
							this.staff = arr1;
							this.staffz = arr1;
							this.staffcopy = this.staff;
						}


					})
					.catch((err) => {
						this.loading = false;
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},

			/**查看 */
			viewDoc(row) {
				this.$router.push({
					path: "quanbugongdanxq",
					query: {
						zhuangtai: 'N',
						qianyiyemingcheng: '全部工单查询',
						code: row.row.CODE,
						qianyiyemianglujing: "/home/quanbugongdanchaxun"
					}
				});
			},
			addDate() {
				let nowDate = new Date();
				let date = {
					year: nowDate.getFullYear(),
					month: nowDate.getMonth() + 1,
					date: nowDate.getDate(),
				};

				if (date.month < 10) {
					date.month = '0' + date.month; //补齐
				}
				if (date.date < 10) {
					date.date = '0' + date.date; //补齐
				}
				// let shijianshuzu = [];
				let shijian = date.year + "-" + date.month + "-" + date.date;
				let shijianks = date.year + "-" + date.month + "-01";

				this.kaishishijian = shijianks;
				this.jieshushijian = shijian;


			},

			/**分页size改变 */
			hanSiChange(val) {
				this.pageSize = val;
				this.currPage = 1;
				this.ChaXun(this.currPage);

			},
			/**当前页改变 */
			hanCurrChange(val) {
				this.currPage = val;
				this.ChaXun(this.currPage);

			},





		},
	};
</script>

<style scoped>
	.weijiekongdan {
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		/* padding: 20px; */
		padding-left: 0px;
		background-color: #F0F0F0;
	}

	.el-main {
		background-color: #F0F0F0;
		padding: 0px;
	}


	/* 头部选择模板名称 */
	.header {
		height: auto;
		background-color: #FFFFFF;
		padding-left: 20px;
		padding-top: 20px;
		/* width: calc(100%-10px); */
	}

	.headerTop {
		display: flex;
		justify-content: space-between;
	}

	.header-con {
		height: auto;
		/* width: calc(100%-200px); */
		display: flex;
		align-items: center;
	}

	.header-con-form {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		word-wrap: break-word;
		overflow: hidden;
		margin: auto
			/* 看自己需要设置，不影响div高度变化*/
	}

	.header-con-form-item {
		margin-bottom: 15px;

	}


	.list {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		width: 100%;
		height: 100%;
	}

	.item {
		width: 100%;
		height: 100%;
	}

	.itema {
		margin-top: 10px;
		box-sizing: border-box;
		width: 100%;
		border-radius: 4px;
		height: 30px;
	}

	.itemb {
		margin-top: 10px;
		box-sizing: border-box;
		width: 100%;
		border-radius: 4px;
		margin-bottom: 0px;
		bottom: 0px;
	}

	.itemaBoxa {
		float: left;
		margin-top: 3px;
		margin-left: 0px;
		margin-left: 4px;
		width: 100px;
		height: 30px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 25px;
		color: #000000;
		opacity: 1;
	}

	.itemaBoxb {
		float: left;
		margin-top: 0px;
		margin-left: 20px;
		width: 200px;
		height: 20%;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 25px;
		color: #000000;
		opacity: 1;
	}

	.itemaBoxc {
		float: left;
		margin-top: 0px;
		margin-left: 20px;
		width: 100px;
		height: 20%;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 25px;
		color: #000000;
		opacity: 1;
	}

	.itemBox {
		box-sizing: border-box;
		width: 100%;
		border: 1px solid #ebeef5;
		background-color: #fff;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
		height: 80px;
	}

	.itemBoxa {
		float: left;
		top: 20px;
		left: 0px;
		margin-left: 4px;
		width: 20%;
		height: 20%;
	}

	.itemBoxb {
		float: left;
		top: 20px;
		left: 20%;
		margin-left: 4px;
		width: 20%;
		height: 20%;
	}

	.itemBoxc {
		float: left;
		top: 20px;
		left: 40%;
		margin-left: 4px;
		width: 20%;
		height: 20%;
	}

	.itemBoxd {
		float: left;
		top: 20px;
		left: 60%;
		margin-left: 4px;
		width: 20%;
		height: 20%;
	}

	.anniuclass {
		margin-left: 20px;
		/* margin-top: 10px; */
		margin-bottom: 15px;
	}

	.itemTop {
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 80px;
		padding: 0 25px;
		/* border-bottom: 1px solid #F2F4F9; */
	}

	.itemTopText {
		float: left;
		width: 80px;
		height: 22px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		line-height: 25px;
		color: #000000;
		opacity: 1;
		margin-left: 10rpx;
	}

	.sousuoyou {
		float: right;
		margin-top: 20px;
		/* right: 30px; */
		margin-right: 20px;
		width: 92px;
		height: 36px;
		font-size: 16px;
		line-height: 18px;
		text-align: center;
		/* width: 100%;
  height: 100%; */
		overflow: hidden;
		/* background-color: #fff; */
	}

	.container {
		width: 100%;
		height: 100%;
		box-sizing: border-box;

	}


	/* 主体容器 */
	.main {
		margin-top: 10px;
		height: 590px;
		overflow-y: auto;
		margin-right: 0px;
	}

	/* 主体容器 */
	.maina {
		margin-top: 10px;
		height: 590px;
		overflow-y: auto;
		margin-right: 0px;
	}

	.yemakuandu {
		width: 99%;
		background-color: #fff;
		height: 40px;
		padding-top: 20px;
	}

	/**输入框宽度 */
	.input {
		width: 200px;
	}

	/**dialog中样式 */
	.dialog-con {
		height: 375px;
		overflow: auto;
	}

	.itemc {
		margin-top: 10px;
		box-sizing: border-box;
		width: 100%;
		margin-bottom: 10px;
		/* height: 98%; */
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		overflow-y: auto;
	}

	.itemcBoxa {
		width: 49.95%;
		height: 70px;
		max-height: 100px;
		float: none;

		background-color: #fff;
	}

	.itemd {
		box-sizing: border-box;
		width: 100%;
		height: 98%;
		background-color: #fff;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		overflow-y: auto;
	}

	.itemdtext {
		margin-left: 10px;
		margin-top: 20px;
		margin-bottom: 10px;
		width: 80%;
		height: 22px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 22px;
		color: #181818;
		opacity: 1;
		text-decoration: underline;
	}

	.itemdtexta {
		margin-left: 10px;
		margin-top: 20px;
		margin-bottom: 10px;
		width: 16%;
		height: 22px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 22px;
		color: #181818;
		opacity: 1;
		text-decoration: underline;
	}

	/**底部分页 */
	.footer {
		height: 50px;
		margin-right: 0px;
	}

	/**输入框宽度 */
	.form-item-inputcpx {
		width: 200px;
	}






	.containera {
		width: 100%;
		height: 100%;
		padding-left: 10px;
		margin-top: -10px;
		box-sizing: border-box;
		background-color: #FFFFFF;
	}

	.headerxjgd {
		margin-top: 10px;
		margin-bottom: 15px;
		padding-left: 20px;
	}

	.headeraxjgd {
		margin-bottom: 2px;
	}



	.fanhuiBtnxjgd {
		margin-top: 0px;
		margin-left: 0px;
		margin-bottom: 20px;
		display: inline-block;
	}



	.yonghuminglabexjgd {
		margin-top: 0px;
		margin-left: 90px;
		margin-bottom: 20px;
		display: inline-block;
	}

	/* 主体容器 */
	.mainxjgd {
		height: 100%;
		/* overflow: hidden; */
		background-color: #fff;
		padding: 0px;
		margin-top: 20px;
		box-sizing: border-box;
	}

	/* 主体容器 */
	.mainxjgda {
		height: 100%;
		/* overflow: hidden; */
		background-color: #fff;
		padding: 0px;
		margin-top: 20px;
		box-sizing: border-box;
	}

	.tijiaobtnxjgd {
		/* display: flex; */
		margin-top: 30px;
		margin-left: 50%;
		text-align: center;
		/* margin-left: 100px; */
		width: 100px;
	}

	.tijiaobtnxjgdza {
		/* display: flex; */
		margin-top: 30px;
		text-align: center;
		/* margin-left: 100px; */
		width: 50%;
		display: inline-block;
	}

	.tckmingcheng {
		width: 100%;
		margin-left: 10px;
		text-align: center;
		font-size: 16px;
		color: #333333;
	}

	.tckmingchenga {
		width: 100%;
		margin-left: 10px;
		text-align: center;
		font-size: 16px;
		color: #333333;
		margin-top: 30px;

	}

	.tijiaobtnxjgda {
		/* display: flex; */
		margin-top: 0px;
		margin-left: 40%;
		margin-bottom: 20px;
		text-align: center;
		/* margin-left: 100px; */
		width: 100px;
		display: inline-block;
	}

	.tijiaobtnxjgdb {
		/* display: flex; */
		margin-top: 0px;
		margin-bottom: 20px;
		margin-right: 20%;
		text-align: center;
		/* margin-left: 100px; */
		width: 100px;
		display: inline-block;
	}

	.header-conxjgd {
		margin-left: 0px;
	}

	.header-conaxjgd {
		display: flex;
		align-items: center;
		height: 30px;
		margin-left: 30px;
	}


	.header-con-formxjgd {
		display: flex;
		align-items: center;
	}

	.sousuomingcheng {
		text-align: center;
		display: inline-block;
		margin-right: 10px;
		margin-left: 20px;
		font-size: 15px;
		font-weight: 400;
	}


	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatarxjgd {
		width: 178px;
		height: 178px;
		display: block;
	}

	.el-card {
		box-shadow: 0 1px 1px #F5F5F5 !important;
	}

	/deep/.eloption .el-select-dropdown__wrap {
		max-height: 400px !important;
	}

	/deep/ .el-select__tags {

		flex-wrap: nowrap;
		overflow: hidden;
	}

	.el-table {
		overflow-y: auto !important;
		overflow-x: auto !important;
	}

	/* 	/deep/ .el-dialog {
		height: 80%;
	} */
</style>
